/**
 * IMPORTS
 */

import type { ISincronizarCamposVariaveisModeloPayloadDto } from "@/data/dtos/modelos/sincronizar-campos-variaveis-modelo-dto";
import type { ISincronizarCamposVariaveisModeloResponseApi } from "@/data/dtos/response-api/modelos/sincronizar-campos-variaveis-modelo-response-api";
import { axiosClient } from "@/data/http/axios/axios-client";
import type { ISincronizarCamposVariaveisModeloRepository } from "@/domain/repositories/modelos/sincronizar-campos-variaveis-modelo-repository-contract";

class SincronizarCamposVariaveisModeloRepositoryImplementation implements ISincronizarCamposVariaveisModeloRepository {
  async sincronizarCamposPorModelo(
    modeloTecnicoId: number,
    payload: ISincronizarCamposVariaveisModeloPayloadDto
  ): Promise<ISincronizarCamposVariaveisModeloResponseApi> {
    return axiosClient<ISincronizarCamposVariaveisModeloResponseApi>(
      `modelos-tecnicos-campos-variaveis/modelo/${modeloTecnicoId}`,
      {
        method: "put",
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }
}

/**
 * EXPORT
 */
export { SincronizarCamposVariaveisModeloRepositoryImplementation };
